import { Config } from './config-service.interface';
import { object, string, boolean, number } from 'zod';

/**
 * Schema to validate the ConfigDto.
 */
const schema = object({
  blockedCashPlayStates: object({
    abbr: string(),
    state: string(),
  }).array(),
  daysToCancelApprovedRequests: number(),
  depositFee: number(),
  withdrawalFee: number(),
  useDelayKyc: boolean(),
});

/**
 * Represents the configuration data transfer object.
 */
export class ConfigDto {
  blockedCashPlayStates: { abbr: string; state: string }[];
  daysToCancelApprovedRequests: number;
  depositFee: number;
  withdrawalFee: number;
  useDelayKyc: boolean;

  /**
   * Creates a new instance of ConfigDto.
   * @param obj - The partial object to assign to the instance.
   */
  constructor(obj: Partial<Omit<ConfigDto, 'fromJson' | 'toDomain'>>) {
    Object.assign(this, obj);
  }

  /**
   * Creates a new instance of ConfigDto from a JSON object.
   * @param json - The JSON object to create the instance from.
   * @returns A new instance of ConfigDto.
   */
  static fromJson(json: object): ConfigDto {
    // validate object
    const result = schema.parse(json);

    return new ConfigDto(result as unknown as ConfigDto);
  }

  /**
   * Converts the ConfigDto instance to a Config domain object.
   * @returns A new instance of Config.
   */
  toDomain(): Config {
    return {
      blockedCashPlayStates: this.blockedCashPlayStates,
      daysToCancelApprovedRequests: this.daysToCancelApprovedRequests,
      depositFee: this.depositFee,
      withdrawalFee: this.withdrawalFee,
      requireKycVerification: this.useDelayKyc,
    };
  }
}
